import { render, staticRenderFns } from "./CoaSelect.vue?vue&type=template&id=23de685c&"
import script from "./CoaSelect.vue?vue&type=script&lang=ts&"
export * from "./CoaSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23de685c')) {
      api.createRecord('23de685c', component.options)
    } else {
      api.reload('23de685c', component.options)
    }
    module.hot.accept("./CoaSelect.vue?vue&type=template&id=23de685c&", function () {
      api.rerender('23de685c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/CoaSelect.vue"
export default component.exports